import React, { useState, useEffect } from "react";
import Select from "react-select";
import { Formik, Form, Field, ErrorMessage } from "formik";
import * as Yup from "yup";
import PhoneInput from "react-phone-input-2";
import "react-phone-input-2/lib/style.css";
import { Link, useNavigate, useParams } from "react-router-dom";
import { useDispatch } from "react-redux";
import toast from "react-hot-toast";
import {
  uploadProfilePic,
  uploadAadharcardPic,
  getDistrictList,
  getTalukaList,
  getVillageList,
  getOccupationList,
  getEducationList,
  addEditUserAnalytics,
  getOneUserAnalytics,
  useUserAnalytics,
} from "../../Redux/Slices/userAnalyticsSlice";
import moment from "moment";
import { Image } from "primereact/image";

function AddEditUseAnalytics() {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  let { id } = useParams();

  const [profileImage, setProfileImage] = useState(null);
  const [imagePreview, setImagePreview] = useState(null);
  const [aadharCardImages, setAadharCardImages] = useState([]);
  const [aadharImagePreviews, setAadharImagePreviews] = useState([]);
  const [isProfileUploading, setIsProfileUploading] = useState(false);
  const [isAadharFrontUploading, setIsAadharFrontUploading] = useState(false);
  const [isAadharBackUploading, setIsAadharBackUploading] = useState(false);
  const [villages, setVillages] = useState([]);
  const [talukas, setTalukas] = useState([]);
  const [districts, setDistricts] = useState([]);
  const [educations, setEducations] = useState([]);
  const [occupations, setOccupations] = useState([]);
  const [redirectTarget, setRedirectTarget] = useState("family");

  // Search states for searchable dropdowns
  const [districtSearch, setDistrictSearch] = useState("");
  const [talukaSearch, setTalukaSearch] = useState("");
  const [villageSearch, setVillageSearch] = useState("");
  const [educationSearch, setEducationSearch] = useState("");
  const [occupationSearch, setOccupationSearch] = useState("");
  const [selectedDistrictId, setSelectedDistrictId] = useState("");
  const [selectedTalukaId, setSelectedTalukaId] = useState("");

  const menuPortalStyles = {
    menuPortal: (base) => ({ ...base, zIndex: 9999 }),
  };

  // Year dropdown options
  const currentYear = new Date().getFullYear();

  const [allData, setAllData] = useState([]);
  const [formValues, setFormValues] = useState({
    name: "",
    fathername: "",
    address: "",
    business_address: "",
  });

  const handleGujaratiChange = (e, setFieldValue) => {
    const { name, value } = e.target;

    const gujaratiOnly = /^[\u0A80-\u0AFF\d\s]*$/;

    if (value === "" || gujaratiOnly.test(value)) {
      setFieldValue(name, value);
    }
  };

  const initialValues = {
    userId: "",
    profilepic: null,
    aadharcard: [],
    villageId: "",
    talukaId: "",
    districtId: "",
    surname: "સવાણી",
    name: "",
    fathername: "",
    dob: "",
    age: "",
    // is_married: "",
    address: "",
    countryCode: "",
    mobile: "",
    optional_countryCode: "",
    optional_mobile: "",
    businessCategoryId: "",
    education: "",
    business_address: "",
    country_wise_contact: "",
    optional_country_wise_contact: "",
    joiningyear: new Date().getFullYear().toString(),
  };

  const fetchAnalyticsData = async () => {
    if (id) {
      const payload = { userId: id };
      try {
        const res = await dispatch(getOneUserAnalytics(payload)).unwrap();
        if (res.IsSuccess) {
          setAllData(res?.Data);
        }
        // if (data.Data?.media) {
        //   setFileName(
        //     data?.Data?.media
        //       ? {
        //           name: data?.Data?.media?.name || "",
        //           url: baseImageUrl + data?.Data?.media?.path,
        //         }
        //       : {}
        //   );
        // }
      } catch (error) {
        console.error("Error fetching data:", error);
      }
    }
  };
  const validationSchema = Yup.object({
    villageId: Yup.string().required("Village is Required"),
    talukaId: Yup.string().required("Takula isRequired"),
    districtId: Yup.string().required("District isRequired"),
    surname: Yup.string().required("Surname is Required"),
    name: Yup.string().required("Name is Required"),
    fathername: Yup.string().required("Fatharname is Required"),
    // dob: Yup.string().required('Date of Birth is Required'),
    mobile: Yup.string().required("Mobile no is Required"),
  });

  const handleProfileImage = async (event, setFieldValue) => {
    const file = event.target.files[0];
    if (!file) return;
    try {
      setIsProfileUploading(true);
      setImagePreview(URL.createObjectURL(file));
      const formData = new FormData();
      formData.append("profilepic", file);

      const response = await dispatch(uploadProfilePic(formData)).unwrap();
      if (response.IsSuccess) {
        setProfileImage(response.Data);
        setFieldValue("profile_pic", response.Data);
        toast.success(response.Message);
      } else {
        throw new Error(response.Message || "Image upload failed");
      }
    } catch (error) {
      console.error("Upload failed:", error);
      toast.error(error.message || "Image upload failed. Please try again.");
      setImagePreview(null);
      setProfileImage(null);
    } finally {
      setIsProfileUploading(false);
    }
  };

  const handleDeleteProfile = (setFieldValue) => {
    setImagePreview(null);
    setProfileImage(null);
    setFieldValue("profile_pic", null);
  };

  const handleAadharCardImage = async (event, setFieldValue, side) => {
    const file = event.target.files[0];
    if (!file) return;

    try {
      // Set loading state based on which side is being uploaded
      if (side === "front") {
        setIsAadharFrontUploading(true);
      } else {
        setIsAadharBackUploading(true);
      }

      const preview = URL.createObjectURL(file);
      const formData = new FormData();
      formData.append("aadharcard", file);

      const response = await dispatch(uploadAadharcardPic(formData)).unwrap();
      if (response.IsSuccess) {
        const newImages = [...aadharCardImages];
        const newPreviews = [...aadharImagePreviews];

        if (side === "front") {
          newImages[0] = response.Data;
          newPreviews[0] = preview;
        } else {
          newImages[1] = response.Data;
          newPreviews[1] = preview;
        }

        setAadharCardImages(newImages);
        setAadharImagePreviews(newPreviews);
        setFieldValue("aadharcard", newImages);
        toast.success(response.Message);
      } else {
        throw new Error(response.Message || "Image upload failed");
      }
    } catch (error) {
      toast.error(error.message || "Image upload failed. Please try again.");
    } finally {
      if (side === "front") {
        setIsAadharFrontUploading(false);
      } else {
        setIsAadharBackUploading(false);
      }
    }
  };

  const handleDeleteImage = (setFieldValue, side) => {
    const newImages = [...aadharCardImages];
    const newPreviews = [...aadharImagePreviews];

    if (side === "front") {
      newImages[0] = null;
      newPreviews[0] = null;
    } else {
      newImages[1] = null;
      newPreviews[1] = null;
    }

    setAadharCardImages(newImages);
    setAadharImagePreviews(newPreviews);
    setFieldValue("aadharcard", newImages);
  };

  const getDistrict = async (search = "") => {
    try {
      const response = await dispatch(getDistrictList({ search })).unwrap();
      if (response.IsSuccess) {
        setDistricts(response.Data || []);
      }
    } catch (error) {
      toast.error("Failed to fetch Districts");
    }
  };

  const getTaluka = async (districtId, search = "") => {
    try {
      const response = await dispatch(getTalukaList({ districtId, search })).unwrap();
      if (response.IsSuccess) {
        const filteredTalukas = response.Data.filter(
          (taluka) => taluka.districtId?._id === districtId,
        );
        setTalukas(filteredTalukas || []);
      }
    } catch (error) {
      toast.error("Failed to fetch Talukas");
    }
  };

  const getVillage = async (talukaId, search = "") => {
    try {
      const response = await dispatch(getVillageList({ talukaId, search })).unwrap();
      if (response.IsSuccess) {
        const filteredVillages = response.Data.filter(
          (village) => village.talukaId?._id === talukaId,
        );
        setVillages(filteredVillages || []);
      }
    } catch (error) {
      toast.error("Failed to fetch Villages");
    }
  };

  const getEducation = async (search = "") => {
    try {
      const response = await dispatch(getEducationList({ search })).unwrap();
      if (response.IsSuccess) {
        setEducations(response.Data || []);
      }
    } catch (error) {
      toast.error("Failed to fetch Education");
    }
  };

  const getOccupation = async (search = "") => {
    try {
      const response = await dispatch(getOccupationList({ search })).unwrap();
      if (response.IsSuccess) {
        setOccupations(response.Data || []);
      }
    } catch (error) {
      toast.error("Failed to fetch Business");
    }
  };

  const handleSubmit = async (values) => {
    if (!values) {
      toast.error("Form data is missing.");
      return;
    }
    const aadharcardImages = aadharCardImages.filter(
      (img) => img !== null && img !== undefined,
    );

    const payload = {
      ...values,
      userId: id || "",
      districtId: values.districtId || "",
      talukaId: values.talukaId || "",
      villageId: values.villageId || "",
      profile_pic: profileImage || "",
      aadharcard: aadharcardImages, // Pass the filtered array directly
      surname: values.surname || "",
      name: values.name || "",
      fathername: values.fathername || "",
      dob:
        values.dob && moment(values.dob, "YYYY-MM-DD", true).isValid()
          ? moment(values.dob).format("DD/MM/YYYY")
          : "",
      age: Number(values.age) || "",
      joiningyear: values.joiningyear || "",
      countryCode: values.countryCode || "+91",
      mobile: values.mobile || "",
      optional_countryCode: values.optional_countryCode || "+91",
      optional_mobile: values.optional_mobile || "",
      // is_married: Boolean(values.is_married),
      address: values?.address || "",
      education: values.education || "",
      businessCategoryId: values.businessCategoryId || "",
      business_address: values.business_address || "",
      // is_youngtarang: values.is_youngtarang || "",
      country_wise_contact: {
        number: values.mobile || "",
        internationalNumber:
          `${values.countryCode || "+91"} ${values.mobile || ""}`.trim(),
        nationalNumber: values.mobile || "",
        e164Number:
          `${values.countryCode || "+91"}${values.mobile || ""}`.replace(
            /\s/g,
            "",
          ),
        countryCode: values.countryCode.replace("+", "").toUpperCase(),
        dialCode: values.countryCode || "+91",
      },
      optional_country_wise_contact: {
        number: values.optional_mobile || "",
        internationalNumber:
          `${values.optional_countryCode || "+91"} ${values.optional_mobile || ""}`.trim(),
        nationalNumber: values.optional_mobile || "",
        e164Number:
          `${values.optional_countryCode || "+91"}${values.optional_mobile || ""}`.replace(
            /\s/g,
            "",
          ),
        countryCode: values.optional_countryCode.replace("+", "").toUpperCase(),
        dialCode: values.optional_countryCode || "+91",
      },
    };

    try {
      const response = await dispatch(addEditUserAnalytics(payload)).unwrap();

      if (response.IsSuccess) {
        toast.success(response.Message);
        if (redirectTarget === "family") {
          navigate(`/edit-family-list/${response?.Data?._id}`);
        } else {
          navigate(`/users-analytics`);
        }
      } else {
        toast.error(
          response.Message || "Something went wrong. Please try again.",
        );
      }
    } catch (error) {
      console.error("Error submitting form: ", error);

      // When using unwrap(), the error object contains the rejected value directly
      const errorMessage =
        error?.error?.Message ||
        error?.data?.Message ||
        error?.Message ||
        error?.message;
      toast.error(errorMessage || "An unexpected error occurred");
    }
  };

  useEffect(() => {
    setTimeout(() => {
      if (id) {
        fetchAnalyticsData();
      }
    }, 500);
    getDistrict();
  }, [id]);

  useEffect(() => {
    const timer = setTimeout(() => getDistrict(districtSearch), 500);
    return () => clearTimeout(timer);
  }, [districtSearch]);

  useEffect(() => {
    if (selectedDistrictId) {
      const timer = setTimeout(() => getTaluka(selectedDistrictId, talukaSearch), 500);
      return () => clearTimeout(timer);
    }
  }, [talukaSearch, selectedDistrictId]);

  useEffect(() => {
    if (selectedTalukaId) {
      const timer = setTimeout(() => getVillage(selectedTalukaId, villageSearch), 500);
      return () => clearTimeout(timer);
    }
  }, [villageSearch, selectedTalukaId]);

  useEffect(() => {
    const timer = setTimeout(() => getEducation(educationSearch), 500);
    return () => clearTimeout(timer);
  }, [educationSearch]);

  useEffect(() => {
    const timer = setTimeout(() => getOccupation(occupationSearch), 500);
    return () => clearTimeout(timer);
  }, [occupationSearch]);

  useEffect(() => {
    setTimeout(() => {
      if (allData) {
        setFormValues({
          userId: allData?._id || "",
          profile_pic: allData?.profile_pic || "",
          aadharcard: allData?.aadharcard || [],
          villageId: allData?.village?._id || "",
          talukaId: allData?.taluka?._id || "",
          districtId: allData?.district?._id || "",
          surname: allData?.surname || "સવાણી",
          name: allData?.name || "",
          fathername: allData?.fathername || "",
          dob: allData?.dob
            ? moment(allData.dob, "DD/MM/YYYY").format("YYYY-MM-DD")
            : "",
          age: allData?.age || "",
          joiningyear: allData?.joiningyear || currentYear.toString(),
          // is_married: allData?.is_married || false,
          address: allData?.address || "",
          countryCode:
            allData?.countryCode ||
            allData?.country_wise_contact?.countryCode ||
            "+91",
          mobile:
            allData?.mobile || allData?.country_wise_contact?.number || "",
          optional_countryCode:
            allData?.optional_country_wise_contact?.dialCode || "+91",
          optional_mobile: allData?.optional_country_wise_contact?.number || "",
          education: allData?.education?._id || "",
          businessCategoryId: allData?.business?._id || "",
          business_address: allData?.business_address || "",
          // is_youngtarang: allData?.is_youngtarang || "",
          country_wise_contact: allData?.country_wise_contact || {},
          optional_country_wise_contact:
            allData?.optional_country_wise_contact || {},
        });

        // Set Aadhar card images and previews
        if (allData?.aadharcard) {
          // Check if aadharcard is an array or string
          const aadharImages = Array.isArray(allData.aadharcard)
            ? allData.aadharcard
            : typeof allData.aadharcard === "string"
              ? allData.aadharcard.split(",")
              : [];

          setAadharCardImages(aadharImages);
          setAadharImagePreviews(aadharImages);
        }

        if (allData?.profile_pic) {
          setImagePreview(allData?.profile_pic);
          setProfileImage(allData?.profile_pic);
        }

        // Load related talukas and villages
        if (allData?.district?._id) {
          getTaluka(allData.district._id);
        }
        if (allData?.taluka?._id) {
          getVillage(allData.taluka._id);
        }
      } else {
        setFormValues({
          ...initialValues,
          surname: "સવાણી",
        });
        setImagePreview(null);
        setProfileImage(null);
        setAadharCardImages([]);
        setAadharImagePreviews([]);
      }
    }, 200);
  }, [allData]);

  return (
    <>
      {/* <div className="bg-gray-50"> */}
      <div className="mx-auto bg-white rounded-lg shadow-sm">
        <Formik
          initialValues={formValues}
          validationSchema={validationSchema}
          onSubmit={handleSubmit}
          enableReinitialize={true}
        >
          {({ isSubmitting, setFieldValue, values }) => {
            // console.log("values",values);
            return (
              <Form className="w-full px-6 pb-6">
                <div className="flex flex-wrap justify-between items-center p-4">
                  <Link
                    to="/users-analytics"
                    className="text-gray_2 flex items-center"
                  >
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      className="h-5 w-5 mr-1"
                      viewBox="0 0 20 20"
                      fill="currentColor"
                    >
                      <path
                        fillRule="evenodd"
                        d="M9.707 16.707a1 1 0 01-1.414 0l-6-6a1 1 0 010-1.414l6-6a1 1 0 011.414 1.414L5.414 9H17a1 1 0 110 2H5.414l4.293 4.293a1 1 0 010 1.414z"
                        clipRule="evenodd"
                      />
                    </svg>
                    Back
                  </Link>
                  <div className="flex items-center space-x-2">
                    <button
                      type="submit"
                      disabled={
                        isSubmitting ||
                        isProfileUploading ||
                        isAadharFrontUploading ||
                        isAadharBackUploading
                      }
                      className={`btn ${isSubmitting || isProfileUploading || isAadharFrontUploading || isAadharBackUploading ? "opacity-50 cursor-not-allowed" : ""}`}
                      onClick={() => setRedirectTarget("family")}
                    >
                      {isSubmitting && redirectTarget === "family"
                        ? "Submitting..."
                        : "Family Member"}
                    </button>
                    <button
                      type="submit"
                      disabled={
                        isSubmitting ||
                        isProfileUploading ||
                        isAadharFrontUploading ||
                        isAadharBackUploading
                      }
                      className={`btn ${isSubmitting || isProfileUploading || isAadharFrontUploading || isAadharBackUploading ? "opacity-50 cursor-not-allowed" : ""}`}
                      onClick={() => setRedirectTarget("analytics")}
                    >
                      {isSubmitting && redirectTarget === "analytics"
                        ? "Submitting..."
                        : "Save"}
                    </button>
                  </div>
                </div>
                <div className="flex flex-wrap lg:flex-nowrap items-center">
                  <div className="w-36 flex items-center mb-8 mr-0 lg:mr-5">
                    <div className="relative">
                      <div className="w-36 h-36 rounded-xl border-dashed border border-primary overflow-hidden group">
                        {isProfileUploading ? (
                          <div className="w-full h-full flex items-center justify-center bg-gray-100">
                            <div className="animate-spin rounded-full h-8 w-8 border-b-2 border-primary"></div>
                          </div>
                        ) : imagePreview ? (
                          <div className="w-full h-full flex items-center justify-center cursor-pointer">
                            <Image
                              src={imagePreview}
                              alt="Profile"
                              className="w-full h-full object-cover"
                              preview={true}
                            />
                            <div className="absolute top-2 right-2 opacity-0 group-hover:opacity-100 transition-opacity z-50">
                              <button
                                onClick={() =>
                                  handleDeleteProfile(setFieldValue)
                                }
                                className="bg-white/90 backdrop-blur-sm text-red p-1.5 rounded-md shadow-md hover:bg-white transition-colors"
                                title="Delete Image"
                              >
                                <svg
                                  xmlns="http://www.w3.org/2000/svg"
                                  className="h-5 w-5"
                                  fill="none"
                                  viewBox="0 0 24 24"
                                  stroke="currentColor"
                                >
                                  <path
                                    strokeLinecap="round"
                                    strokeLinejoin="round"
                                    strokeWidth={2}
                                    d="M19 7l-.867 12.142A2 2 0 0116.138 21H7.862a2 2 0 01-1.995-1.858L5 7m5 4v6m4-6v6m1-10V4a1 1 0 00-1-1h-4a1 1 0 00-1 1v3M4 7h16"
                                  />
                                </svg>
                              </button>
                            </div>
                          </div>
                        ) : (
                          <div className="w-full h-full bg-gray-100 flex items-center justify-center">
                            <svg
                              width="149"
                              height="149"
                              viewBox="0 0 149 149"
                              fill="none"
                              xmlns="http://www.w3.org/2000/svg"
                            >
                              <mask
                                id="mask0_1_594"
                                style={{ marginRight: 0 + "em" }}
                                maskUnits="userSpaceOnUse"
                                x="0"
                                y="0"
                                width="149"
                                height="149"
                              >
                                <rect
                                  x="0.571289"
                                  y="0.5"
                                  width="147.929"
                                  height="147.929"
                                  rx="9.5"
                                  fill="#F9F9F9"
                                  stroke="#8897AE"
                                />
                              </mask>
                              <g mask="url(#mask0_1_594)">
                                <path
                                  d="M74.5355 7.0918C51.3097 7.0918 32.4277 25.9738 32.4277 49.1996C32.4277 71.9821 50.246 90.4209 73.4717 91.2187C74.1809 91.1301 74.8901 91.1301 75.422 91.2187C75.5993 91.2187 75.6879 91.2187 75.8652 91.2187C75.9539 91.2187 75.9539 91.2187 76.0425 91.2187C98.7364 90.4209 116.555 71.9821 116.643 49.1996C116.643 25.9738 97.7613 7.0918 74.5355 7.0918Z"
                                  fill="#8897AE"
                                />
                                <path
                                  d="M119.568 114.798C94.8355 98.3095 54.5007 98.3095 29.5906 114.798C18.3323 122.333 12.127 132.528 12.127 143.431C12.127 154.335 18.3323 164.441 29.502 171.887C41.9127 180.22 58.2239 184.387 74.5351 184.387C90.8463 184.387 107.158 180.22 119.568 171.887C130.738 164.352 136.943 154.246 136.943 143.254C136.855 132.35 130.738 122.244 119.568 114.798Z"
                                  fill="#8897AE"
                                />
                              </g>
                            </svg>
                            <div className="w-10 h-10 bg-[#D9D9D9] rounded-full flex items-center justify-center border-2 border-b4 absolute bottom-0 right-0 z-20 cursor-pointer">
                              <span className="text-18 cursor-pointer">
                                <svg
                                  width="22"
                                  height="23"
                                  viewBox="0 0 22 23"
                                  fill="none"
                                  xmlns="http://www.w3.org/2000/svg"
                                >
                                  <path
                                    d="M16.9998 5.14314C16.3462 5.14314 15.7462 4.76814 15.4462 4.18956L14.6748 2.63599C14.1819 1.66099 12.8962 0.857422 11.8033 0.857422H9.34976C8.24619 0.857422 6.96047 1.66099 6.46762 2.63599L5.69619 4.18956C5.39619 4.76814 4.79619 5.14314 4.14262 5.14314C1.81762 5.14314 -0.025239 7.10385 0.124761 9.41814L0.681904 18.2681C0.810475 20.4753 1.99976 22.286 4.9569 22.286H16.1855C19.1426 22.286 20.3212 20.4753 20.4605 18.2681L21.0176 9.41814C21.1676 7.10385 19.3248 5.14314 16.9998 5.14314ZM8.96405 6.48242H12.1783C12.6176 6.48242 12.9819 6.84671 12.9819 7.28599C12.9819 7.72528 12.6176 8.08956 12.1783 8.08956H8.96405C8.52476 8.08956 8.16047 7.72528 8.16047 7.28599C8.16047 6.84671 8.52476 6.48242 8.96405 6.48242ZM10.5712 18.1289C8.57833 18.1289 6.94976 16.511 6.94976 14.5074C6.94976 12.5038 8.56762 10.886 10.5712 10.886C12.5748 10.886 14.1926 12.5038 14.1926 14.5074C14.1926 16.511 12.564 18.1289 10.5712 18.1289Z"
                                    fill="#2D3643"
                                  />
                                </svg>
                              </span>
                              <input
                                type="file"
                                onChange={(e) =>
                                  handleProfileImage(e, setFieldValue)
                                }
                                className="absolute inset-0 w-full h-full opacity-0 cursor-pointer"
                                accept="image/*"
                              />
                            </div>
                          </div>
                        )}
                      </div>
                    </div>
                  </div>
                  <div className="w-full">
                    <div className="flex flex-wrap items-center -mx-3">
                      <div className="w-full md:w-1/2 lg:w-1/3 md:px-3 mb-6">
                        <label className="block text-sm font-medium text-gray-700 mb-1">
                          સભ્યના જિલ્લાનું નામ
                          <span className="text-red text-18">*</span>
                        </label>
                        <Select
                          id="districtId"
                          name="districtId"
                          filterOption={() => true}
                          inputValue={districtSearch}
                          onInputChange={(inputValue, { action }) => {
                            if (action === "input-change") setDistrictSearch(inputValue);
                          }}
                          onBlur={() => setDistrictSearch("")}
                          options={districts.map((item) => ({
                            value: item?._id,
                            label: item?.gujarati_name,
                          }))}
                          value={
                            districts
                              .filter((d) => d._id === values.districtId)
                              .map((item) => ({
                                value: item?._id,
                                label: item?.gujarati_name,
                              }))[0] || null
                          }
                          onChange={(selected) => {
                            const districtId = selected ? selected.value : "";
                            setDistrictSearch("");
                            setFieldValue("districtId", districtId);
                            setFieldValue("talukaId", "");
                            setFieldValue("villageId", "");
                            setTalukas([]);
                            setVillages([]);
                            setSelectedDistrictId(districtId);
                            setSelectedTalukaId("");
                            if (districtId) getTaluka(districtId);
                          }}
                          placeholder="Select District"
                          classNamePrefix="react-select"
                          menuPortalTarget={document.body}
                          styles={menuPortalStyles}
                          isClearable
                        />
                        <ErrorMessage
                          name="districtId"
                          component="div"
                          className="text-red text-sm mt-1"
                        />
                      </div>
                      <div className="w-full md:w-1/2 lg:w-1/3 md:px-3 mb-6">
                        <label className="block text-sm font-medium text-gray-700 mb-1">
                          સભ્યના તાલુકાનું નામ
                          <span className="text-red text-18">*</span>
                        </label>
                        <Select
                          id="talukaId"
                          name="talukaId"
                          filterOption={() => true}
                          inputValue={talukaSearch}
                          onInputChange={(inputValue, { action }) => {
                            if (action === "input-change") setTalukaSearch(inputValue);
                          }}
                          onBlur={() => setTalukaSearch("")}
                          options={talukas.map((item) => ({
                            value: item?._id,
                            label: item?.gujarati_name,
                          }))}
                          value={
                            talukas
                              .filter((t) => t._id === values.talukaId)
                              .map((item) => ({
                                value: item?._id,
                                label: item?.gujarati_name,
                              }))[0] || null
                          }
                          onChange={(selected) => {
                            const talukaId = selected ? selected.value : "";
                            setTalukaSearch("");
                            setFieldValue("talukaId", talukaId);
                            setFieldValue("villageId", "");
                            setVillages([]);
                            setSelectedTalukaId(talukaId);
                            if (talukaId) getVillage(talukaId);
                          }}
                          placeholder="Select Taluka"
                          classNamePrefix="react-select"
                          menuPortalTarget={document.body}
                          styles={menuPortalStyles}
                          isClearable
                        />
                        <ErrorMessage
                          name="talukaId"
                          component="div"
                          className="text-red text-sm mt-1"
                        />
                      </div>
                      <div className="w-full md:w-1/2 lg:w-1/3 md:px-3 mb-6">
                        <label className="block text-sm font-medium text-gray-700 mb-1">
                          સભ્યના ગામનું નામ
                          <span className="text-red text-18">*</span>
                        </label>
                        <Select
                          id="villageId"
                          name="villageId"
                          filterOption={() => true}
                          inputValue={villageSearch}
                          onInputChange={(inputValue, { action }) => {
                            if (action === "input-change") setVillageSearch(inputValue);
                          }}
                          onBlur={() => setVillageSearch("")}
                          options={villages.map((item) => ({
                            value: item?._id,
                            label: item?.gujarati_name,
                          }))}
                          value={
                            villages
                              .filter((v) => v._id === values.villageId)
                              .map((item) => ({
                                value: item?._id,
                                label: item?.gujarati_name,
                              }))[0] || null
                          }
                          onChange={(selected) => {
                            setVillageSearch("");
                            setFieldValue("villageId", selected ? selected.value : "");
                          }}
                          placeholder="Select Village"
                          classNamePrefix="react-select"
                          menuPortalTarget={document.body}
                          styles={menuPortalStyles}
                          isClearable
                        />
                        <ErrorMessage
                          name="villageId"
                          component="div"
                          className="text-red text-sm mt-1"
                        />
                      </div>
                    </div>
                  </div>
                </div>

                <div className="flex flex-wrap -mx-3">
                  <div className="w-full md:w-1/2 lg:w-1/3 px-3 mb-6">
                    <label className="block text-sm font-medium text-gray-700 mb-1">
                      મુખ્ય સભ્યની અટક
                      <span className="text-red text-18">*</span>
                    </label>
                    <Field
                      name="surname"
                      type="text"
                      className="w-full p-2 border border-gray-300 rounded-md bg-gray-100 focus:outline-none"
                      placeholder="મુખ્ય સભ્યની અટક"
                      readOnly
                    />
                  </div>

                  <div className="w-full md:w-1/2 lg:w-1/3 px-3 mb-6">
                    <label className="block text-sm font-medium text-gray-700 mb-1">
                      મુખ્ય સભ્યનું નામ
                      <span className="text-red text-18">*</span>
                    </label>
                    <Field
                      name="name"
                      className="w-full p-2 border border-gray-300 rounded-md"
                      placeholder="મુખ્ય સભ્યનું નામ"
                      onChange={(e) => handleGujaratiChange(e, setFieldValue)}
                    />
                    <ErrorMessage
                      name="name"
                      component="div"
                      className="text-red text-sm mt-1"
                    />
                  </div>

                  <div className="w-full md:w-1/2 lg:w-1/3 px-3 mb-6">
                    <label className="block text-sm font-medium text-gray-700 mb-1">
                      મુખ્ય સભ્યના પિતા નું નામ
                      <span className="text-red text-18">*</span>
                    </label>
                    <Field
                      name="fathername"
                      className="w-full p-2 border border-gray-300 rounded-md"
                      placeholder="મુખ્ય સભ્યના પિતા નું નામ"
                      onChange={(e) => handleGujaratiChange(e, setFieldValue)}
                    />
                    <ErrorMessage
                      name="fathername"
                      component="div"
                      className="text-red text-sm mt-1"
                    />
                  </div>

                  <div className="w-full md:w-1/2 lg:w-1/3 px-3 mb-6">
                    <label className="block text-sm font-medium text-gray-700 mb-1">
                      સભ્ય બન્યાનું વર્ષ
                      <span className="text-red text-18">*</span>
                    </label>
                    <Field
                      name="joiningyear"
                      type="text"
                      className="w-full p-2 border border-gray-300 rounded-md bg-gray-100 focus:outline-none"
                      placeholder="સભ્ય બન્યાનું વર્ષ"
                      disabled
                      value={values.joiningyear || currentYear.toString()}
                    />
                    <ErrorMessage
                      name="joiningyear"
                      component="div"
                      className="text-red text-sm mt-1"
                    />
                  </div>

                  <div className="w-full md:w-1/2 lg:w-1/3 px-3 mb-6">
                    <label className="block text-sm font-medium text-gray-700 mb-1">
                      જન્મ તારીખ
                    </label>
                    <Field
                      type="date"
                      name="dob"
                      className="w-full p-2 border border-gray-300 rounded-md"
                      placeholder="જન્મ તારીખ"
                      onChange={(e) => {
                        const dob = e.target.value;
                        setFieldValue("dob", dob);

                        // Calculate age when date of birth changes
                        if (dob) {
                          const birthDate = new Date(dob);
                          const currentYear = new Date().getFullYear();
                          const birthYear = birthDate.getFullYear();
                          const calculatedAge = currentYear - birthYear;

                          setFieldValue("age", calculatedAge);
                        }
                      }}
                    />
                    <ErrorMessage
                      name="dob"
                      component="div"
                      className="text-red text-sm mt-1"
                    />
                  </div>

                  <div className="w-full md:w-1/2 lg:w-1/3 px-3 mb-6">
                    <label className="block text-sm font-medium text-gray-700 mb-1">
                      ઉંમર
                    </label>
                    <Field
                      type="text"
                      name="age"
                      className="w-full p-2 border border-gray-300 rounded-md focus:outline-none bg-slate-100"
                      placeholder="ઉંમર"
                      readOnly
                    />
                  </div>

                  {/* <div className="w-full md:w-1/2 lg:w-1/3 px-3 mb-6">
                    <label className="block text-sm font-medium text-gray-700 mb-1">
                      તમે પરિણીત છો કે નહીં?
                    </label>
                    <Field
                      as="select"
                      name="is_married"
                      className="w-full p-2.5 border border-gray-300 rounded-md"
                      placeholder="તમે પરિણીત છો કે નહીં?"
                    >
                      <option value="">તમે પરિણીત છો કે નહીં?</option>
                      <option value="true">પરિણીત</option>
                      <option value="false">અપરિણીત</option>
                    </Field>
                  </div> */}

                  <div className="w-full md:w-1/2 lg:w-1/3 px-3 mb-6">
                    <label className="block text-sm font-medium text-gray-700 mb-1">
                      મોબાઈલ નંબર<span className="text-red text-18">*</span>
                    </label>
                    <div className="flag_drop input_phone">
                      <PhoneInput
                        name="mobile"
                        inputClass="w-full p-2 border border-gray-300 rounded-md"
                        placeholder="મોબાઈલ નંબર"
                        // country={'in'}
                        value={`${values.countryCode}${values.mobile}`}
                        // value={values.country_wise_contact.e164Number.toString()}
                        onChange={(phone, countryData) => {
                          const dialCodeLength = countryData.dialCode.length;
                          setFieldValue("mobile", phone.slice(dialCodeLength)); // Remove dial code from the number
                          setFieldValue(
                            "countryCode",
                            `+${countryData.dialCode}`,
                          ); // Set correct country code
                          setFieldValue("country_wise_contact", {
                            number: phone.slice(dialCodeLength),
                            internationalNumber:
                              `${countryData.dialCode} ${phone.slice(dialCodeLength)}`.trim(),
                            nationalNumber: phone.slice(dialCodeLength),
                            e164Number:
                              `${countryData.dialCode} ${phone.slice(dialCodeLength)}`.replace(
                                /\s/g,
                                "",
                              ),
                            countryCode: countryData.countryCode.toUpperCase(),
                            dialCode: values.countryCode || "+91",
                          });
                        }}
                        // country={values.countryCode ? values.countryCode.replace("+", "") : "in"}
                        inputProps={{
                          name: "mobile",
                          required: true,
                          autoFocus: true,
                        }}
                      />
                    </div>
                    <ErrorMessage
                      name="mobile"
                      component="div"
                      className="text-red text-sm mt-1"
                    />
                  </div>

                  <div className="w-full md:w-1/2 lg:w-1/3 px-3 mb-6">
                    <label className="block text-sm font-medium text-gray-700 mb-1">
                      વૈકલ્પિક મોબાઈલ નંબર
                    </label>
                    <div className="flag_drop input_phone">
                      <PhoneInput
                        name="optional_mobile"
                        inputClass="w-full p-2 border border-gray-300 rounded-md"
                        placeholder="વૈકલ્પિક મોબાઈલ નંબર"
                        // country={'in'}
                        value={`${values.optional_countryCode}${values.optional_mobile}`}
                        // value={values.optional_country_wise_contact.e164Number.toString()}
                        // country={values.optional_countryCode ? values.optional_countryCode.replace("+", "") : "in"}
                        onChange={(phone, countryData) => {
                          const dialCodeLength = countryData.dialCode.length;
                          const phoneNumber = phone.slice(dialCodeLength);
                          setFieldValue("optional_mobile", phoneNumber);
                          setFieldValue(
                            "optional_countryCode",
                            `+${countryData.dialCode}`,
                          );
                          setFieldValue("optional_country_wise_contact", {
                            number: phoneNumber,
                            internationalNumber:
                              `+${countryData.dialCode} ${phoneNumber}`.trim(),
                            nationalNumber: phoneNumber,
                            e164Number:
                              `+${countryData.dialCode}${phoneNumber}`.replace(
                                /\s/g,
                                "",
                              ),
                            countryCode: countryData.countryCode.toUpperCase(),
                            dialCode: `+${countryData.dialCode}`,
                          });
                        }}
                        inputProps={{
                          name: "optional_mobile",
                          required: false, // Assuming it's optional, unlike primary mobile
                          autoFocus: false,
                        }}
                      />
                    </div>
                    <ErrorMessage
                      name="optional_mobile"
                      component="div"
                      className="text-red text-sm mt-1"
                    />
                  </div>

                  <div className="w-full md:w-full px-3 mb-6">
                    <label className="block text-sm font-medium text-gray-700 mb-1">
                      સરનામું
                    </label>
                    <Field
                      name="address"
                      className="w-full p-2 border border-gray-300 rounded-md"
                      placeholder="સરનામું"
                    />
                  </div>

                  <div className="w-full md:w-1/2 px-3 mb-6">
                    <label className="block text-sm font-medium text-gray-700 mb-1">
                      અભ્યાસ
                    </label>
                    <Select
                      id="education"
                      name="education"
                      filterOption={() => true}
                      inputValue={educationSearch}
                      onInputChange={(inputValue, { action }) => {
                        if (action === "input-change") setEducationSearch(inputValue);
                      }}
                      onBlur={() => setEducationSearch("")}
                      options={educations.map((item) => ({
                        value: item?._id,
                        label: item?.gujarati_name,
                      }))}
                      value={
                        educations
                          .filter((e) => e._id === values.education)
                          .map((item) => ({
                            value: item?._id,
                            label: item?.gujarati_name,
                          }))[0] || null
                      }
                      onChange={(selected) => {
                        setEducationSearch("");
                        setFieldValue("education", selected ? selected.value : "");
                      }}
                      placeholder="Select Education"
                      classNamePrefix="react-select"
                      menuPortalTarget={document.body}
                      styles={menuPortalStyles}
                      isClearable
                    />
                  </div>

                  <div className="w-full md:w-1/2 px-3">
                    <label className="block text-sm font-medium text-gray-700 mb-1">
                      વ્યવસાય
                    </label>
                    <Select
                      id="businessCategoryId"
                      name="businessCategoryId"
                      filterOption={() => true}
                      inputValue={occupationSearch}
                      onInputChange={(inputValue, { action }) => {
                        if (action === "input-change") setOccupationSearch(inputValue);
                      }}
                      onBlur={() => setOccupationSearch("")}
                      options={occupations.map((item) => ({
                        value: item?._id,
                        label: item?.gujarati_name,
                      }))}
                      value={
                        occupations
                          .filter((o) => o._id === values.businessCategoryId)
                          .map((item) => ({
                            value: item?._id,
                            label: item?.gujarati_name,
                          }))[0] || null
                      }
                      onChange={(selected) => {
                        setOccupationSearch("");
                        setFieldValue("businessCategoryId", selected ? selected.value : "");
                      }}
                      placeholder="Select Business"
                      classNamePrefix="react-select"
                      menuPortalTarget={document.body}
                      styles={menuPortalStyles}
                      isClearable
                    />
                  </div>

                  <div className="w-full px-3 mb-4">
                    <label className="block text-sm font-medium text-gray-700 mb-1">
                      ધંધો - વ્યવસાયનું સરનામું
                    </label>
                    <Field
                      name="business_address"
                      className="w-full p-2 border border-gray-300 rounded-md"
                      placeholder="ધંધો - વ્યવસાયનું સરનામું"
                    // onChange={(e) => handleGujaratiChange(e, setFieldValue)}
                    />
                  </div>
                  {/* <div className="w-full md:w-1/2 px-3 mb-4">
                    <label className="block text-sm font-medium text-gray-700 mb-1">
                      યંગ તરંગના સભ્યો છો કે નહીં?
                    </label>
                    <Field
                      as="select"
                      name="is_youngtarang"
                      className="w-full p-2.5 border border-gray-300 rounded-md"
                      placeholder="યંગ તરંગના સભ્યો છો કે નહીં?"
                    >
                      <option value="" selected>
                        હા/ના
                      </option>
                      <option value="true">હા</option>
                      <option value="false">ના</option>
                    </Field>
                  </div> */}
                  <div className="w-full md:w-1/2 px-3 mb-6">
                    <label className="block text-sm font-medium text-gray-700 mb-1">
                      આધાર કાર્ડનો આગળ ફોટો
                    </label>
                    <div className="relative border-2 border-dashed border-gray-300 rounded-lg group">
                      <div className="w-full h-36 flex items-center justify-center relative">
                        {isAadharFrontUploading ? (
                          <div className="w-full h-full flex items-center justify-center bg-gray-100">
                            <div className="animate-spin rounded-full h-8 w-8 border-b-2 border-primary"></div>
                          </div>
                        ) : aadharImagePreviews[0] ? (
                          <div className="relative w-[100%] h-full rounded-lg overflow-hidden z-50 mx-auto group">
                            <Image
                              src={aadharImagePreviews[0]}
                              alt="Aadhar Front Preview"
                              className="w-full h-full object-contain mx-auto"
                              preview={true}
                            />
                            <div className="absolute top-2 right-2 opacity-0 group-hover:opacity-100 transition-opacity z-50">
                              <button
                                onClick={() =>
                                  handleDeleteImage(setFieldValue, "front")
                                }
                                className="bg-white/90 backdrop-blur-sm text-red p-1.5 rounded-md shadow-md hover:bg-white transition-colors"
                                title="Delete Image"
                              >
                                <svg
                                  xmlns="http://www.w3.org/2000/svg"
                                  className="h-5 w-5"
                                  fill="none"
                                  viewBox="0 0 24 24"
                                  stroke="currentColor"
                                >
                                  <path
                                    strokeLinecap="round"
                                    strokeLinejoin="round"
                                    strokeWidth={2}
                                    d="M19 7l-.867 12.142A2 2 0 0116.138 21H7.862a2 2 0 01-1.995-1.858L5 7m5 4v6m4-6v6m1-10V4a1 1 0 00-1-1h-4a1 1 0 00-1 1v3M4 7h16"
                                  />
                                </svg>
                              </button>
                            </div>
                          </div>
                        ) : (
                          <div className="text-center">
                            <div className="flex justify-center">
                              <svg
                                width="32"
                                height="32"
                                viewBox="0 0 32 32"
                                fill="none"
                                xmlns="http://www.w3.org/2000/svg"
                              >
                                <path
                                  d="M11.9999 14.3333C9.97325 14.3333 8.33325 12.6933 8.33325 10.6667C8.33325 8.64 9.97325 7 11.9999 7C14.0266 7 15.6666 8.64 15.6666 10.6667C15.6666 12.6933 14.0266 14.3333 11.9999 14.3333ZM11.9999 9C11.5579 9 11.134 9.17559 10.8214 9.48816C10.5088 9.80072 10.3333 10.2246 10.3333 10.6667C10.3333 11.1087 10.5088 11.5326 10.8214 11.8452C11.134 12.1577 11.5579 12.3333 11.9999 12.3333C12.4419 12.3333 12.8659 12.1577 13.1784 11.8452C13.491 11.5326 13.6666 11.1087 13.6666 10.6667C13.6666 10.2246 13.491 9.80072 13.1784 9.48816C12.8659 9.17559 12.4419 9 11.9999 9Z"
                                  fill="#9BA0A8"
                                />
                                <path
                                  d="M20 30.3334H12C4.75996 30.3334 1.66663 27.2401 1.66663 20.0001V12.0001C1.66663 4.76008 4.75996 1.66675 12 1.66675H17.3333C17.88 1.66675 18.3333 2.12008 18.3333 2.66675C18.3333 3.21341 17.88 3.66675 17.3333 3.66675H12C5.85329 3.66675 3.66663 5.85341 3.66663 12.0001V20.0001C3.66663 26.1467 5.85329 28.3334 12 28.3334H20C26.1466 28.3334 28.3333 26.1467 28.3333 20.0001V13.3334C28.3333 12.7867 28.7866 12.3334 29.3333 12.3334C29.88 12.3334 30.3333 12.7867 30.3333 13.3334V20.0001C30.3333 27.2401 27.24 30.3334 20 30.3334Z"
                                  fill="#9BA0A8"
                                />
                                <path
                                  d="M24 11.6667C23.4533 11.6667 23 11.2133 23 10.6667V2.66667C23 2.26667 23.24 1.89333 23.6133 1.74667C23.9867 1.6 24.4133 1.68 24.7067 1.96L27.3733 4.62667C27.76 5.01333 27.76 5.65333 27.3733 6.04C26.9867 6.42667 26.3467 6.42667 25.96 6.04L25 5.08V10.6667C25 11.2133 24.5467 11.6667 24 11.6667Z"
                                  fill="#9BA0A8"
                                />
                                <path
                                  d="M21.3333 6.3335C21.0799 6.3335 20.8266 6.24017 20.6266 6.04017C20.4406 5.85198 20.3363 5.59807 20.3363 5.3335C20.3363 5.06893 20.4406 4.81502 20.6266 4.62683L23.2932 1.96017C23.6799 1.5735 24.3199 1.5735 24.7066 1.96017C25.0933 2.34683 25.0933 2.98683 24.7066 3.3735L22.0399 6.04017C21.8399 6.24017 21.5866 6.3335 21.3333 6.3335ZM3.55992 26.2668C3.3468 26.2654 3.13971 26.1959 2.96878 26.0686C2.79785 25.9413 2.672 25.7628 2.60953 25.559C2.54706 25.3553 2.55124 25.1369 2.62145 24.9356C2.69166 24.7344 2.82425 24.5608 2.99992 24.4402L9.57325 20.0268C11.0133 19.0668 12.9999 19.1735 14.3066 20.2802L14.7466 20.6668C15.4132 21.2402 16.5466 21.2402 17.1999 20.6668L22.7466 15.9068C24.1599 14.6935 26.3866 14.6935 27.8133 15.9068L29.9866 17.7735C30.3999 18.1335 30.4532 18.7602 30.0933 19.1868C29.7332 19.6002 29.0933 19.6535 28.6799 19.2935L26.5066 17.4268C25.8399 16.8535 24.7199 16.8535 24.0533 17.4268L18.5066 22.1868C17.0933 23.4002 14.8666 23.4002 13.4399 22.1868L12.9999 21.8002C12.3866 21.2802 11.3733 21.2268 10.6933 21.6935L4.13325 26.1068C3.94658 26.2135 3.74658 26.2668 3.55992 26.2668Z"
                                  fill="#9BA0A8"
                                />
                              </svg>
                            </div>
                          </div>
                        )}
                      </div>
                      <input
                        type="file"
                        className="absolute inset-0 w-full h-full opacity-0 cursor-pointer"
                        accept="image/*"
                        onChange={(e) =>
                          handleAadharCardImage(e, setFieldValue, "front")
                        }
                      />
                    </div>
                  </div>

                  <div className="w-full md:w-1/2 px-3 mb-6">
                    <label className="block text-sm font-medium text-gray-700 mb-1">
                      આધાર કાર્ડનો પાછળ ફોટો
                    </label>
                    <div className="relative border-2 border-dashed border-gray-300 rounded-lg group">
                      <div className="w-full h-36 flex items-center justify-center relative">
                        {isAadharBackUploading ? (
                          <div className="w-full h-full flex items-center justify-center bg-gray-100">
                            <div className="animate-spin rounded-full h-8 w-8 border-b-2 border-primary"></div>
                          </div>
                        ) : aadharImagePreviews[1] ? (
                          <div className="relative w-[100%] h-full rounded-lg overflow-hidden z-50 mx-auto group">
                            <Image
                              src={aadharImagePreviews[1]}
                              alt="Aadhar Back Preview"
                              className="w-full h-full object-contain mx-auto"
                              preview={true}
                            />
                            <div className="absolute top-2 right-2 opacity-0 group-hover:opacity-100 transition-opacity z-50">
                              <button
                                onClick={() =>
                                  handleDeleteImage(setFieldValue, "back")
                                }
                                className="bg-white/90 backdrop-blur-sm text-red p-1.5 rounded-md shadow-md hover:bg-white transition-colors"
                                title="Delete Image"
                              >
                                <svg
                                  xmlns="http://www.w3.org/2000/svg"
                                  className="h-5 w-5"
                                  fill="none"
                                  viewBox="0 0 24 24"
                                  stroke="currentColor"
                                >
                                  <path
                                    strokeLinecap="round"
                                    strokeLinejoin="round"
                                    strokeWidth={2}
                                    d="M19 7l-.867 12.142A2 2 0 0116.138 21H7.862a2 2 0 01-1.995-1.858L5 7m5 4v6m4-6v6m1-10V4a1 1 0 00-1-1h-4a1 1 0 00-1 1v3M4 7h16"
                                  />
                                </svg>
                              </button>
                            </div>
                          </div>
                        ) : (
                          <div className="text-center">
                            <div className="flex justify-center">
                              <svg
                                width="32"
                                height="32"
                                viewBox="0 0 32 32"
                                fill="none"
                                xmlns="http://www.w3.org/2000/svg"
                              >
                                <path
                                  d="M11.9999 14.3333C9.97325 14.3333 8.33325 12.6933 8.33325 10.6667C8.33325 8.64 9.97325 7 11.9999 7C14.0266 7 15.6666 8.64 15.6666 10.6667C15.6666 12.6933 14.0266 14.3333 11.9999 14.3333ZM11.9999 9C11.5579 9 11.134 9.17559 10.8214 9.48816C10.5088 9.80072 10.3333 10.2246 10.3333 10.6667C10.3333 11.1087 10.5088 11.5326 10.8214 11.8452C11.134 12.1577 11.5579 12.3333 11.9999 12.3333C12.4419 12.3333 12.8659 12.1577 13.1784 11.8452C13.491 11.5326 13.6666 11.1087 13.6666 10.6667C13.6666 10.2246 13.491 9.80072 13.1784 9.48816C12.8659 9.17559 12.4419 9 11.9999 9Z"
                                  fill="#9BA0A8"
                                />
                                <path
                                  d="M20 30.3334H12C4.75996 30.3334 1.66663 27.2401 1.66663 20.0001V12.0001C1.66663 4.76008 4.75996 1.66675 12 1.66675H17.3333C17.88 1.66675 18.3333 2.12008 18.3333 2.66675C18.3333 3.21341 17.88 3.66675 17.3333 3.66675H12C5.85329 3.66675 3.66663 5.85341 3.66663 12.0001V20.0001C3.66663 26.1467 5.85329 28.3334 12 28.3334H20C26.1466 28.3334 28.3333 26.1467 28.3333 20.0001V13.3334C28.3333 12.7867 28.7866 12.3334 29.3333 12.3334C29.88 12.3334 30.3333 12.7867 30.3333 13.3334V20.0001C30.3333 27.2401 27.24 30.3334 20 30.3334Z"
                                  fill="#9BA0A8"
                                />
                                <path
                                  d="M24 11.6667C23.4533 11.6667 23 11.2133 23 10.6667V2.66667C23 2.26667 23.24 1.89333 23.6133 1.74667C23.9867 1.6 24.4133 1.68 24.7067 1.96L27.3733 4.62667C27.76 5.01333 27.76 5.65333 27.3733 6.04C26.9867 6.42667 26.3467 6.42667 25.96 6.04L25 5.08V10.6667C25 11.2133 24.5467 11.6667 24 11.6667Z"
                                  fill="#9BA0A8"
                                />
                                <path
                                  d="M21.3333 6.3335C21.0799 6.3335 20.8266 6.24017 20.6266 6.04017C20.4406 5.85198 20.3363 5.59807 20.3363 5.3335C20.3363 5.06893 20.4406 4.81502 20.6266 4.62683L23.2932 1.96017C23.6799 1.5735 24.3199 1.5735 24.7066 1.96017C25.0933 2.34683 25.0933 2.98683 24.7066 3.3735L22.0399 6.04017C21.8399 6.24017 21.5866 6.3335 21.3333 6.3335ZM3.55992 26.2668C3.3468 26.2654 3.13971 26.1959 2.96878 26.0686C2.79785 25.9413 2.672 25.7628 2.60953 25.559C2.54706 25.3553 2.55124 25.1369 2.62145 24.9356C2.69166 24.7344 2.82425 24.5608 2.99992 24.4402L9.57325 20.0268C11.0133 19.0668 12.9999 19.1735 14.3066 20.2802L14.7466 20.6668C15.4132 21.2402 16.5466 21.2402 17.1999 20.6668L22.7466 15.9068C24.1599 14.6935 26.3866 14.6935 27.8133 15.9068L29.9866 17.7735C30.3999 18.1335 30.4532 18.7602 30.0933 19.1868C29.7332 19.6002 29.0933 19.6535 28.6799 19.2935L26.5066 17.4268C25.8399 16.8535 24.7199 16.8535 24.0533 17.4268L18.5066 22.1868C17.0933 23.4002 14.8666 23.4002 13.4399 22.1868L12.9999 21.8002C12.3866 21.2802 11.3733 21.2268 10.6933 21.6935L4.13325 26.1068C3.94658 26.2135 3.74658 26.2668 3.55992 26.2668Z"
                                  fill="#9BA0A8"
                                />
                              </svg>
                            </div>
                          </div>
                        )}
                      </div>
                      <input
                        type="file"
                        className="absolute inset-0 w-full h-full opacity-0 cursor-pointer"
                        accept="image/*"
                        onChange={(e) =>
                          handleAadharCardImage(e, setFieldValue, "back")
                        }
                      />
                    </div>
                  </div>

                  {/* <div className="w-full md:w-1/2 px-3 mb-4">
                    <label className="block text-sm font-medium text-gray-700 mb-1">
                      યંગ તરંગના સભ્યો છો કે નહીં?
                    </label>
                    <Field
                      as="select"
                      name="is_youngtarang"
                      className="w-full p-2.5 border border-gray-300 rounded-md"
                      placeholder="યંગ તરંગના સભ્યો છો કે નહીં?"
                    >
                      <option value="" selected>
                        હા/ના
                      </option>
                      <option value="true">હા</option>
                      <option value="false">ના</option>
                    </Field>
                  </div> */}
                </div>
              </Form>
            );
          }}
        </Formik>
      </div>
      {/* </div> */}
    </>
  );
}

export default AddEditUseAnalytics;
